//#region Auth
export const LOGIN = 'LOGIN';
export const VERIFY_CODE = 'VERIFY_CODE';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const NEW_PASSWORD = 'NEW_PASSWORD';
//#endregion Auth

//#region User
export const GET_LIST_USER = 'GET_LIST_USER';
export const GET_DETAIL_USER = 'GET_DETAIL_USER';
export const CREATE_USER = 'CREATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const CHANGE_PASSWORD_USER = 'CHANGE_PASSWORD_USER';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
//#endregion User

//#region Client
export const GET_LIST_CLIENT = 'GET_LIST_CLIENT';
export const GET_DETAIL_CLIENT = 'GET_DETAIL_CLIENT';
export const CREATE_CLIENT = 'CREATE_CLIENT';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const DELETE_CLIENT = 'DELETE_CLIENT';
//#endregion Client

//#region Coupon
export const GET_LIST_COUPON = 'GET_LIST_COUPON';
export const GET_DETAIL_COUPON = 'GET_DETAIL_COUPON';
export const CREATE_COUPON = 'CREATE_COUPON';
export const UPDATE_COUPON = 'UPDATE_COUPON';
export const DELETE_COUPON = 'DELETE_COUPON';
//#endregion Coupon

//#region Quote
export const GET_LIST_QUOTE = 'GET_LIST_QUOTE';
export const GET_DETAIL_QUOTE = 'GET_DETAIL_QUOTE';
export const CREATE_QUOTE = 'CREATE_QUOTE';
export const DELETE_QUOTE = 'DELETE_QUOTE';
export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const CONVERT_QUOTE_TO_ORDER = 'CONVERT_QUOTE_TO_ORDER';
export const CHANGE_STATUS_QUOTE = 'CHANGE_STATUS_QUOTE';
export const CLONE_QUOTE = 'CLONE_QUOTE';
export const SEND_MAIL_QUOTE = 'SEND_MAIL_QUOTE';
//#endregion Quote

//#region Global
export const GET_LIST_GLOBAL = 'GET_LIST_GLOBAL';
//#endregion Global

//#region Inventory
export const GET_LIST_INVENTORY_QUOTE = 'GET_LIST_INVENTORY_QUOTE';
export const GET_LIST_INVENTORY_PRODUCT = 'GET_LIST_INVENTORY_PRODUCT';
export const GET_LIST_INVENTORY_HISTORY = 'GET_LIST_INVENTORY_HISTORY';
export const GET_DETAIL_INVENTORY = 'GET_DETAIL_INVENTORY';
export const CREATE_INVENTORY = 'CREATE_INVENTORY';
export const IMPORT_INVENTORY = 'IMPORT_INVENTORY';
export const DELETE_INVENTORY = 'DELETE_INVENTORY';
export const UPDATE_INVENTORY = 'UPDATE_INVENTORY';
export const EXPORT_INVENTORY = 'EXPORT_INVENTORY';
export const CLONE_INVENTORY = 'CLONE_INVENTORY';
//#endregion Inventory

//#region Inventory
export const GET_LIST_VARIANT = 'GET_LIST_VARIANT';
export const DELETE_VARIANT = 'DELETE_VARIANT';
//#endregion Inventory

//#region Package
export const GET_LIST_PACKAGE = 'GET_LIST_PACKAGE';
export const GET_DETAIL_PACKAGE = 'GET_DETAIL_PACKAGE';
export const CREATE_PACKAGE = 'CREATE_PACKAGE';
export const DELETE_PACKAGE = 'DELETE_PACKAGE';
export const UPDATE_PACKAGE = 'UPDATE_PACKAGE';
export const GET_LIST_ITEM_OPTIONAL_PACKAGE = 'GET_LIST_ITEM_OPTIONAL_PACKAGE';

//#endregion Package

//#region Category
export const GET_LIST_CATEGORY = 'GET_LIST_CATEGORY';
export const GET_DETAIL_CATEGORY = 'GET_DETAIL_CATEGORY';
export const CREATE_CATEGORY = 'CREATE_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
//#endregion Category

//#region File
export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';
export const ATTACH_FILE = 'ATTACH_FILE';
//#endregion File

//#region Activity
export const GET_ACTIVITY_LIST = 'GET_ACTIVITY_LIST';
export const CREATE_CALL_HISTORY = 'CREATE_CALL_HISTORY';
//#endregion Activity

//#region Master Data
export const GET_ACTIVITY_MASTER_DATA = 'GET_ACTIVITY_MASTER_DATA';
export const GET_DETAIL_MASTER_DATA = 'GET_DETAIL_MASTER_DATA';
export const CREATE_MASTER_DATA = 'CREATE_MASTER_DATA';
export const UPDATE_MASTER_DATA = 'UPDATE_MASTER_DATA';
export const DELETE_MASTER_DATA = 'DELETE_MASTER_DATA';
//#endregion Master Data

//#region Schedule
export const GET_LIST_SCHEDULE = 'GET_LIST_SCHEDULE';
export const EXPORT_SCHEDULE = 'EXPORT_SCHEDULE';
export const CHANGE_EVENT_SCHEDULE = 'CHANGE_EVENT_SCHEDULE';
export const REVERT_SCHEDULE_TO_JOB = 'REVERT_SCHEDULE_TO_JOB';
//#endregion Schedule

//#region Order
export const GET_LIST_ORDER = 'GET_LIST_ORDER';
export const GET_LIST_ORDER_EVENT = 'GET_LIST_ORDER_EVENT';
export const CONVERT_ORDER_TO_JOB = 'CONVERT_ORDER_TO_JOB';
export const GET_ORDER_DETAIL = 'GET_ORDER_DETAIL';
export const SPLIT_ORDER = 'SPLIT_ORDER';
export const GET_SPLIT_ORDER = 'GET_SPLIT_ORDER';
export const DELETE_ORDER = 'DELETE_ORDER';
export const UPDATE_ORDER = 'UPDATE_ORDER';
export const REVERT_TO_QUOTE = 'REVERT_TO_QUOTE';
export const SEND_MAIL_ORDER = 'SEND_MAIL_ORDER';
export const CHANGE_STATUS_ORDER = 'CHANGE_STATUS_ORDER';
//#endregion Order

//#region Job
export const CREATE_JOB = 'CREATE_JOB';
export const UPDATE_JOB = 'UPDATE_JOB';
export const CHANGE_STATUS_JOB = 'CHANGE_STATUS_JOB';
export const GET_LIST = 'GET_LIST';
export const DELETE_JOB = 'DELETE_JOB';
export const GET_DETAIL_JOB = 'GET_DETAIL_JOB';
export const GET_LIST_JOB_ITEM = 'GET_LIST_JOB_ITEM';
export const ADDITIONAL_EXPENSE = 'ADDITIONAL_EXPENSE';
export const GET_LIST_JOB_KANBAN = 'GET_LIST_JOB_KANBAN';
export const CONVERT_TO_SCHEDULE = 'CONVERT_TO_SCHEDULE';
//#endregion Job

//#region Checklist
export const GET_CHECKLIST = 'GET_CHECKLIST';
export const CREATE_CHECKLIST = 'CREATE_CHECKLIST';
export const DELETE_CHECKLIST = 'DELETE_CHECKLIST';
export const CREATE_CHECKLIST_ITEM = 'CREATE_CHECKLIST_ITEM';
export const DELETE_CHECKLIST_ITEM = 'DELETE_CHECKLIST_ITEM';
//#endregion Checklist

//#region Incident
export const CREATE_INCIDENT = 'CREATE_INCIDENT';
export const DELETE_INCIDENT = 'DELETE_INCIDENT';
//#endregion Incident

//#region Truck
export const GET_LIST_TRUCK = 'GET_LIST_TRUCK';
export const GET_DETAIL_TRUCK = 'GET_DETAIL_TRUCK';
export const CREATE_TRUCK = 'CREATE_TRUCK';
export const UPDATE_TRUCK = 'UPDATE_TRUCK';
export const DELETE_TRUCK = 'DELETE_TRUCK';
//#endregion Truck

//#region Reports
export const GET_LIST_OVERBOOKING_ITEM_REPORT = 'GET_LIST_OVERBOOKING_ITEM_REPORT';
export const GET_LIST_SUBRENTALS_REPORT = 'GET_LIST_SUBRENTALS_REPORT';
export const GET_LIST_CLIENT_INCOME_REPORT = 'GET_LIST_CLIENT_INCOME_REPORT';
export const GET_LIST_REVENUE_REPORT = 'GET_LIST_REVENUE_REPORT';
export const GET_LIST_GEOGRAPHY_REVENUE_REPORT = 'GET_LIST_GEOGRAPHY_REVENUE_REPORT';
export const GET_LIST_QUOTE_REVENUE_REPORT = 'GET_LIST_QUOTE_REVENUE_REPORT';
export const GET_LIST_ORDER_REVENUE_REPORT = 'GET_LIST_ORDER_REVENUE_REPORT';
export const GET_LIST_CANCELLATION_REPORT = 'GET_LIST_CANCELLATION_REPORT';
export const GET_LIST_DELIVERY_PICKUP_REPORT = 'GET_LIST_DELIVERY_PICKUP_REPORT';
export const GET_LIST_TASK_COMPLETION_REPORT = 'GET_LIST_TASK_COMPLETION_REPORT';
export const GET_LIST_DISCOUNT_USAGE_REPORT = 'GET_LIST_DISCOUNT_USAGE_REPORT';
export const GET_LIST_FEATURE_UTILIZATION_REPORT = 'GET_LIST_FEATURE_UTILIZATION_REPORT';
export const GET_LIST_JOB_COSTING_REPORT = 'GET_LIST_JOB_COSTING_REPORT';
export const GET_LIST_INVENTORY_USAGE_REPORT = 'GET_LIST_INVENTORY_USAGE_REPORT';
export const GET_LIST_FOREMAN_TASK_COMPLETION_REPORT = 'GET_LIST_FOREMAN_TASK_COMPLETION_REPORT';
export const GET_LIST_MARKETING_REVENUE_REPORT = 'GET_LIST_MARKETING_REVENUE_REPORT';
export const GET_LIST_FINANCIAL_ORDER_REPORT = 'GET_LIST_FINANCIAL_ORDER_REPORT';
export const GET_LIST_TRANSACTION_SUMMARY_REPORT = 'GET_LIST_TRANSACTION_SUMMARY_REPORT';
export const EXPORT_DATA_REPORT = 'EXPORT_DATA_REPORT';
//#endregion Reports

//#region Trailer
export const GET_LIST_TRAILER = 'GET_LIST_TRAILER';
export const GET_DETAIL_TRAILER = 'GET_DETAIL_TRAILER';
export const CREATE_TRAILER = 'CREATE_TRAILER';
export const UPDATE_TRAILER = 'UPDATE_TRAILER';
export const DELETE_TRAILER = 'DELETE_TRAILER';
//#endregion Trailer

//#region Equipment
export const GET_LIST_EQUIPMENT = 'GET_LIST_EQUIPMENT';
export const GET_DETAIL_EQUIPMENT = 'GET_DETAIL_EQUIPMENT';
export const CREATE_EQUIPMENT = 'CREATE_EQUIPMENT';
export const UPDATE_EQUIPMENT = 'UPDATE_EQUIPMENT';
export const DELETE_EQUIPMENT = 'DELETE_EQUIPMENT';
//#endregion Equipment

//#region Purchase Order
export const GET_LIST_PURCHASE_ORDER = 'GET_LIST_PURCHASE_ORDER';
export const GET_DETAIL_PURCHASE_ORDER = 'GET_DETAIL_PURCHASE_ORDER';
export const CREATE_PURCHASE_ORDER = 'CREATE_PURCHASE_ORDER';
export const UPDATE_PURCHASE_ORDER = 'UPDATE_PURCHASE_ORDER';
export const CHANGE_STATUS_PURCHASE_ORDER = 'CHANGE_STATUS_PURCHASE_ORDER';
export const DELETE_PURCHASE_ORDER = 'DELETE_TRUCK';
//#endregion Purchase Order

//#region vendors
export const GET_LIST_VENDORS = 'GET_LIST_VENDORS';
export const CREATE_VENDOR = 'CREATE_VENDOR';
export const EDIT_VENDOR = 'EDIT_VENDOR';
export const GET_DETAIL_VENDOR = 'GET_DETAIL_VENDOR';
export const DELETE_VENDOR = 'DELETE_VENDOR';
//#endregion vendors

//#region Appointments
export const CREATE_APPOINTMENT = 'CREATE_APPOINTMENT';
export const DETAIL_APPOINTMENT = 'DETAIL_APPOINTMENT';
export const UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT';
//#endregion Appointments

// #region Task
export const GET_LIST_TASK = 'GET_LIST_TASK';
export const GET_DETAIL_TASK = 'GET_DETAIL_TASK';
export const CREATE_TASK = 'CREATE_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const DELETE_TASK = 'DELETE_TASK';
//#endregion Task

//#region Quarantine
export const GET_LIST_QUARANTINE = 'GET_LIST_QUARANTINE';
export const GET_DETAIL_QUARANTINE = 'GET_DETAIL_QUARANTINE';
export const DELETE_QUARANTINE = 'DELETE_QUARANTINE';
export const CREATE_REPAIRED_QUARANTINE = 'CREATE_REPAIRED_QUARANTINE';
export const CREATE_QUARANTINE = 'CREATE_QUARANTINE';
export const UPDATE_QUARANTINE = 'UPDATE_QUARANTINE';
//#endregion Quarantine

//#region Invoice
export const GET_LIST_INVOICE = 'GET_LIST_INVOICE';
export const GET_DETAIL_INVOICE = 'GET_DETAIL_INVOICE';
export const CREATE_INVOICE = 'CREATE_INVOICE';
export const UPDATE_INVOICE = 'UPDATE_INVOICE';
export const DELETE_INVOICE = 'DELETE_INVOICE';
export const SEND_MAIL_INVOICE = 'SEND_MAIL_INVOICE';
export const CHANGE_STATUS_INVOICE = 'CHANGE_STATUS_INVOICE';
//#endregion Invoice

//#region Payment
export const GET_PAYMENT_LIST = 'GET_PAYMENT_LIST';
export const CREATE_PAYMENT = 'CREATE_PAYMENT';
//#endregion Payment

//#region Role
export const GET_LIST_ROLE = 'GET_LIST_ROLE';
export const GET_DETAIL_ROLE = 'GET_DETAIL_ROLE';
export const CREATE_ROLE = 'CREATE_ROLE';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const DELETE_ROLE = 'DELETE_ROLE';
//#endregion Role

//#region Note
export const CREATE_NOTE = 'CREATE_NOTE';
//#endregion Note

//#region Goal
export const GET_GOAL = 'GET_GOAL';
export const CREATE_SETTING_GOAL = 'CREATE_SETTING_GOAL';
//#endregion Goal

//#region Statistic
export const STATISTIC_CLIENT_TYPE = 'STATISTIC_CLIENT_TYPE';
export const STATISTIC_DASHBOARD_OVERVIEW = 'STATISTIC_DASHBOARD_OVERVIEW';
export const STATISTIC_TODAY_TASK = 'STATISTIC_TODAY_TASK';
export const STATISTIC_TODAY_SCHEDULE = 'STATISTIC_TODAY_SCHEDULE';
export const STATISTIC_ORDER_UNPAID_DEPOSIT = 'STATISTIC_ORDER_UNPAID_DEPOSIT';
export const STATISTIC_ORDER_DEPOSIT_NOT_REQUIRED = 'STATISTIC_ORDER_DEPOSIT_NOT_REQUIRED';
export const STATISTIC_QUOTE_CONVERTED = 'STATISTIC_QUOTE_CONVERTED';
export const STATISTIC_OVERBOOKING_ITEM = 'STATISTIC_OVERBOOKING_ITEM';
export const STATISTIC_OUTSTANDING_SITE_VISIT = 'STATISTIC_OUTSTANDING_SITE_VISIT';
export const STATISTIC_FOREMAN_PERFORMANCE = 'STATISTIC_FOREMAN_PERFORMANCE';
export const STATISTIC_DAILY_LOADING = 'STATISTIC_DAILY_LOADING';
//#endregion Statistic

//#region Category
export const GET_LIST_VENUE = 'GET_LIST_VENUE';
export const GET_DETAIL_VENUE = 'GET_DETAIL_VENUE';
export const CREATE_VENUE = 'CREATE_VENUE';
export const DELETE_VENUE = 'DELETE_VENUE';
export const UPDATE_VENUE = 'UPDATE_VENUE';
//#endregion Category

//#region Truck
export const GET_LIST_LINXUP_TRUCK_LOCATION = 'GET_LIST_LINXUP_TRUCK_LOCATION';
//#endregion Truck
